import axios from "@/helpers/axios";
import {ResearchReport} from "@/types/models/research_report";

export async function fetchResearchReport(id: string) {
    return await axios.post<ResearchReport>(`/reports/${id}`).then(res => res.data);
}

export async function approveResearchReport(id: string) {
    return await axios.post<void>(`/reports/${id}/approve`).then(res => res.data);
}